module.exports = __webpack_public_path__ + "img/6th-grade-en.6db2320a.png";